import React, { useEffect, useState } from 'react';
import { Globals } from '../../../misc/helpers';
import './MenuIcon.css';

const MenuIcon = (props: any) => {
	let [moveRight, setMoveRight] = useState(true);

	const onChangeValueKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13 && props.onClick){ //32 - spacebar, 36 - enter
			props.onClick();
		}
	};

	useEffect(() => {
		if(Globals.stopTimer) {
			setMoveRight(true);
		} else {
			setMoveRight(false);
		}
	}, [Globals.stopTimer]);

	return (
		<div className={`timer-menu-background-left modal-disable-select ${moveRight ? 'timer-animation-right' : 'timer-animation-left'}`}
			aria-label="Tap to pause"
			role="button"
			onClick={props.onClick}
			tabIndex={0}
			onKeyDown={onChangeValueKeyboard}>
			<div className="timer-menu">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>);
};

export default MenuIcon;